export const trackByProp = <T = any>({
  prop,
  fallback = true,
}: {
  prop: keyof T;
  fallback?: boolean;
}) =>
  fallback
    ? (index: number, object: T) => object[prop] ?? object
    : (index: number, object: T) => object[prop];

export const trackByValue = <T>(index: number, value: T): T => value;
